module.exports = __webpack_public_path__ + "img/apple-appstore.8af58064.png";